// Centralised route constants for the property listing-requests module.
// Backend route renames are a one-file change.
//
// Controller base is `admin/listing-requests`; every path is prefixed with
// `/api` (admin-service `docs/listing-requests-admin-api.md §1`).

const LISTING_REQUESTS = '/api/admin/listing-requests'

export const LISTING_REQUESTS_ENDPOINT_PATHS = {
  LIST: LISTING_REQUESTS,
  STATUS_COUNTS: `${LISTING_REQUESTS}/status-counts`,
  DETAIL: (id: string) => `${LISTING_REQUESTS}/${id}`,
  // The append-only activity log behind the detail page's Activity tab.
  TIMELINE: (id: string) => `${LISTING_REQUESTS}/${id}/timeline`,
  // Onboarding fees the seller bears, priced against the price the request
  // stands at. Read-only; its own endpoint rather than a field on the detail
  // because the detail payload is shared with the list, which would then price
  // fees for every row.
  FEE_QUOTE: (id: string) => `${LISTING_REQUESTS}/${id}/fee-quote`,
  // Mints a short-lived signed URL for one intake attachment. `documentType` is
  // the kebab-case wire value from `LISTING_REQUEST_DOCUMENT_TYPE`.
  DOCUMENT_DOWNLOAD_URL: (id: string, documentType: string) =>
    `${LISTING_REQUESTS}/${id}/documents/${documentType}/download-url`,
  APPROVE: (id: string) => `${LISTING_REQUESTS}/${id}/approve`,
  REJECT: (id: string) => `${LISTING_REQUESTS}/${id}/reject`,
  REQUEST_REVISION: (id: string) => `${LISTING_REQUESTS}/${id}/request-revision`,
  PROPOSE_PRICE: (id: string) => `${LISTING_REQUESTS}/${id}/propose-price`,
  SET_FUNDING_WINDOW: (id: string) => `${LISTING_REQUESTS}/${id}/funding-window`,
  // One path, two verbs: PATCH verifies one declared owner, DELETE withdraws
  // that verification. Both are review-stage (status=submitted) and data-only —
  // approving is what completes the owner check and moves the request.
  OWNER_VERIFY: (id: string, index: number) => `${LISTING_REQUESTS}/${id}/owners/${index}/verify`,
  START_OWNER_ONBOARDING: (id: string) => `${LISTING_REQUESTS}/${id}/start-owner-onboarding`,
  ONBOARD_OWNER: (id: string, index: number) => `${LISTING_REQUESTS}/${id}/owners/${index}/onboard`,
  // One path, two verbs: PATCH links, DELETE unlinks.
  OWNER_LINK: (id: string, index: number) => `${LISTING_REQUESTS}/${id}/owners/${index}/link`,
  // Reissuing is a POST to its own path rather than a DELETE+POST on the one
  // below: the server revokes and re-mints in a single step, so exposing it as
  // two calls would let a failure strand the owner with no live link at all.
  RESEND_OWNER_INVITE: (id: string, index: number) =>
    `${LISTING_REQUESTS}/${id}/owners/${index}/resend-invite`,
  OWNER_INVITE: (id: string, index: number) => `${LISTING_REQUESTS}/${id}/owners/${index}/invite`,
  // POST: creates the draft property. Does NOT move the request — the property
  // track runs alongside owner onboarding, so this is a sibling of
  // START_OWNER_ONBOARDING, not a step after it.
  CREATE_DRAFT_PROPERTY: (id: string) => `${LISTING_REQUESTS}/${id}/create-draft-property`,
  // POST, not PATCH like every other transition: promotion returns the property it
  // linked the owner set into.
  PROMOTE: (id: string) => `${LISTING_REQUESTS}/${id}/promote`,
} as const
